var _circle, _circle2, _circle3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoursTimelapseGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.89896,
    cy: 7.54886,
    r: 6.7678,
    stroke: "#808080",
    strokeWidth: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.89891,
    cy: 7.54881,
    r: 5.73436,
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_6696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 12,
    height: 13
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.89891,
    cy: 7.54881,
    r: 5.73436,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_6696)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.678711,
    y: -7.36475,
    width: 7.4796,
    height: 15.4578,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursTimelapseGrey);
export default __webpack_public_path__ + "static/media/hours-timelapse-grey.6c2bccdc1a145be6f9b6bc18ab31c74a.svg";
export { ForwardRef as ReactComponent };